const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', 'minio']);

function isOpenable(value: string): boolean {
    try {
        const u = new URL(value, window.location.origin);
        if (value.startsWith('/') && !/^\/[/\\]/.test(value)) {
            return u.origin === window.location.origin;
        }
        if (/^\//.test(value) || !/^[a-z][a-z\d+.-]*:/i.test(value)) {
            return false;
        }
        return u.protocol === 'https:' || (u.protocol === 'http:' && LOCAL_HOSTS.has(u.hostname));
    } catch {
        return false;
    }
}

export function openHttpsUrl(url: string | null | undefined): boolean {
    const value = (url ?? '').trim();
    if (!isOpenable(value)) {
        return false;
    }
    window.open(value, '_blank', 'noopener');
    return true;
}
